import React, { useContext, useEffect, useState } from "react";
import style from "./OrderSummaryPanel.module.css";
import ButtonEclipse from "components/buttons/ButtonEclipse";
import CheckCircleGroup from "components/inputs/checkBox/CheckCircleGroup";
import Terms from "modals/member/sign/signUp/Terms";
import { addCommas } from "shared/utils/Utils";
import { useTranslation } from "react-i18next";
import P from "components/P";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import FlexChild from "layouts/flex/FlexChild";
import VerticalFlex from "layouts/flex/VerticalFlex";
import PriceRow from "../PriceRow";
import Container from "layouts/container/Container";
import Inline from "layouts/container/Inline";
import Center from "layouts/wrapper/Center";
import plusIcon from "resources/img/icons/mypage/plusIcon.svg";
import InputNumber from "components/inputs/InputNumber";
import { AuthContext } from "providers/AuthProvider";
import { storeRequester } from "App";
import Dummy from "components/Dummy";

const OrderSummaryPanel = ({
  isMobile,
  productTotalPrice,
  VAT,
  onOrderButtonClick,
  onCheckGroupCallback,
  rowIndex,
  agree,
  point,
  usePoint,
  setUsePoint,
  shippingOption,
}) => {
  const { t } = useTranslation();
  // const VAT = productTotalPrice * 0.1;
  const DELIVERY_FEE = shippingOption ? shippingOption?.price_incl_tax : 2500;
  const totalAmount = productTotalPrice + VAT + DELIVERY_FEE;
  return (
    <Container backgroundColor={"white"}>
      {isMobile ? (
        <>
          <div className={style.divider} />
          <div className={style.priceBreakdown}>
            <div className={style.priceRow}>
              <P size={15} weight={600}>
                {t("product")}
                {t("price")}
              </P>
              <P size={15} weight={600}>
                {addCommas(productTotalPrice)} 
              </P>
            </div>
            <div className={style.priceRow}>
              <P size={15} weight={600}>
                {t("vat")}
              </P>
              <P size={15} weight={600}>
                {addCommas(VAT)} 
              </P>
            </div>
            <div className={style.priceRow}>
              <P size={15} weight={600}>
                {t("deliveryFee")}
              </P>
              <P size={15} weight={600}>
                {addCommas(DELIVERY_FEE)} 
              </P>
            </div>
            <div className={style.priceRow}>
              <HorizontalFlex>
                <FlexChild>
                  <Inline>
                    <P color="#666" size={16}>
                      {t("point")}
                    </P>
                    <P color="#666" size={12}>
                      ({t("maximum")} {point || 0}P)
                    </P>
                  </Inline>
                </FlexChild>
                <FlexChild width={"max-content"} justifyContent={"flex-end"}>
                  <InputNumber
                    suffix={
                      <div
                        style={{
                          paddingRight: 5,
                          marginTop: "auto",
                          marginBottom: "auto",
                          fontWeight: "bold",
                          color: "red",
                          display: "flex", 
                          justifyContent: "center",
                          alignItems : "center"
                          
                        }}
                      >
                        <P size={15}>P</P>
                      </div>
                    }
                    min={0}
                    max={point || 0}
                    onChange={(e) => setUsePoint(Number(e))}
                    hideArrow
                    style={{ fontWeight: "bold", color: "red", width: 70, border: "1px solid black", fontSize: "15px", height: "30px" }}
                  />

                </FlexChild>
              </HorizontalFlex>

            </div>
          </div>

          <div className={style.divider} />

          <div className={style.totalAmount}>
            <P size={15} weight={900}>
              {t("amountOfPayment")}
            </P>
            <P size={18} color="var(--main-color)">
              {addCommas(totalAmount - usePoint)} 
            </P>
          </div>

          <CheckCircleGroup
            lineHeight="28px"
            labelWidth={"30px"}
            headerGap={"10px"}
            callback={onCheckGroupCallback}
            flexStart
            padding="7px 15px"
            // backgroundColor= "#F5F5F5"
            header={[
              {
                // width: "90%",
                // padding: "0 0 0 10px",
                text: `${t("termsOfUse")},${t("privacyPolicy")}${t(
                  "useToInfo"
                )}에 동의합니다`,
                alignItems: "center",

              },
            ]}
          >
            {rowIndex?.map((data, index) => (
              <Terms key={index} data={data} index={index} />
            ))}
          </CheckCircleGroup>

          <ButtonEclipse
            onClick={onOrderButtonClick}
            lineHeight="44px"
            fontWeight="bold"
            fontSize="14pt"
            height={44}
            backgroundColor="var(--main-color)"
            text={`${t("makeAPayment")}`}
          />
        </>
      ) : (
        <Container backgroundColor={"white"}>
          <div className={style.summaryWrap}>
            <HorizontalFlex>
              <FlexChild width="initial">
                <VerticalFlex gap={5}>
                  <FlexChild width="initial">
                    <P color="#666" size={16}>
                      {t("productAmountSum")}
                    </P>
                  </FlexChild>
                  <FlexChild width="initial">
                    <P size={23} weight={1000}>
                       {addCommas(productTotalPrice)}
                    </P>
                  </FlexChild>
                </VerticalFlex>
              </FlexChild>
              <FlexChild maxWidth={"max-content"}>
                <img src={plusIcon} width={18} />
              </FlexChild>
              <FlexChild width="initial">
                <VerticalFlex gap={5}>
                  <FlexChild width="initial">
                    <P color="#666" size={16}>
                      {t("vat")}
                    </P>
                  </FlexChild>
                  <FlexChild width="initial">
                    <P size={23} weight={1000}>
                       {addCommas(VAT)}
                    </P>
                  </FlexChild>
                </VerticalFlex>
              </FlexChild>
              <FlexChild maxWidth={"max-content"}>
                <img src={plusIcon} width={18} />
              </FlexChild>
              <FlexChild width="initial">
                <VerticalFlex gap={5}>
                  <FlexChild width="initial">
                    <P color="#666" size={16}>
                      {t("deliveryFee")}
                    </P>
                  </FlexChild>
                  <FlexChild width="initial">
                    <P color="var(--main-color)" size={23} weight={1000}>
                       {addCommas(DELIVERY_FEE)}
                    </P>
                  </FlexChild>
                </VerticalFlex>
              </FlexChild>
              <FlexChild maxWidth={"max-content"}>
                <P color={"var(--main-color)"} weight={900} size={18}>ㅡ</P>
                {/* <img src={plusIcon} width={18} /> */}
              </FlexChild>
              <FlexChild width="initial">
                <VerticalFlex gap={5}>
                  <FlexChild width="initial">
                    <Inline>
                      <P color="#666" size={16}>
                        {t("point")}
                      </P>
                      <P color="#666" size={12}>
                        ({t("maximum")} {point || 0}P)
                      </P>
                    </Inline>
                  </FlexChild>
                  <FlexChild width="initial">
                    <InputNumber
                      suffix={
                        <div
                          style={{
                            paddingRight: 5,
                            marginTop: "auto",
                            marginBottom: "auto",
                            fontWeight: "bold",
                            color: "red",
                          }}
                        >
                          P
                        </div>
                      }
                      min={0}
                      max={point || 0}
                      onChange={(e) => setUsePoint(Number(e))}
                      hideArrow
                      style={{ fontWeight: "bold", width: 90, color: "red" }}
                    />
                  </FlexChild>
                </VerticalFlex>
              </FlexChild>
            </HorizontalFlex>
          </div>
          <div className={style.divider} />
          <HorizontalFlex padding={20} height={"fit-content"}>
            <FlexChild>
              <Inline>
                <P size={23} weight={900}>
                  {t("amountOfPayment")}{" "}
                </P>
                <P size={20} color={"#6C6C6C"} weight={900}>
                  {t("total_amount_plus_vat")}{" "}
                </P>
              </Inline>
            </FlexChild>
            <FlexChild justifyContent={"flex-end"}>
              <P color="var(--main-color)" size={23} weight={900}>
                {addCommas(totalAmount - usePoint)} 
              </P>
            </FlexChild>
          </HorizontalFlex>
          <div className={style.checkWrap}>
            <CheckCircleGroup
              lineHeight="28px"
              callback={onCheckGroupCallback}
              flexStart
              padding="7px 15px"
              header={[
                {
                  width: "98%",
                  text: `${t("termsOfUse")},${t("privacyPolicy")}${t(
                    "useToInfo"
                  )}, ${t("shoppingInfoAgree")}`,
                  alignItems: "center",

                },
              ]}
            >
              {rowIndex?.map((data, index) => (
                <Terms key={index} data={data} index={index} />
              ))}
            </CheckCircleGroup>
          </div>
          <div style={{ height: "fit-content" }}>
            <Center>
              <div style={{ width: "300px" }}>
                <Dummy height={"40px"} />
                <ButtonEclipse
                  onClick={onOrderButtonClick}
                  lineHeight="44px"
                  fontWeight="bold"
                  fontSize="14pt"
                  height={44}
                  backgroundColor="var(--main-color)"
                  text={`${t("makeAPayment")}`}
                />
              </div>
            </Center>
          </div>
        </Container>
      )}
    </Container>
  );
};

export default OrderSummaryPanel;
